const storefrontApiConfig = {
  access_token: "c9d7dcd43c1388da58e094c9de56ac3d",
  shop: window.Shopify.shop,
  api_version: "2026-04",
};

class SpellbindersSupplies extends HTMLElement {
  connectedCallback() {
    this.sku = this.dataset.sku;
    if (!this.sku) return;
    this.loadProduct();
  }

  async loadProduct() {
    try {
      const query = `
        query SkuLookup($q: String!) {
          search(query: $q, types: [PRODUCT], first: 5) {
            edges {
              node {
                ... on Product {
                  title
                  handle
                  onlineStoreUrl
                  featuredImage {
                    url
                    altText
                  }
                  priceRange {
                    minVariantPrice {
                      amount
                      currencyCode
                    }
                  }
                  variants(first: 100) {
                    edges {
                      node {
                        id
                        sku
                        availableForSale
                        compareAtPrice {
                          amount
                          currencyCode
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `;

      const variables = {
        q: this.sku
      };

      const accessToken = storefrontApiConfig.access_token;
      const shop = storefrontApiConfig.shop;
      const apiVersion = storefrontApiConfig.api_version;
      const url = `https://${shop}/api/${apiVersion}/graphql.json`;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': accessToken,
        },
        body: JSON.stringify({ query, variables }),
      });

      const result = await response.json();

      const product = result.data.search.edges
        .map((edge) => edge.node)
          .find((product) => {
            return product.variants.edges.some((variantEdge) => {
            return variantEdge.node.sku === this.sku;
          });
        });

      if (!product) {
        this.style.display = 'none';
        this.innerHTML = '';
        return;
      }

      const variant = product.variants.edges
        .map((edge) => edge.node)
        .find((variant) => variant.sku === this.sku);

      this.renderProduct(product, variant);

    } catch(error) {
      console.error('Error fetching product data:', error);
    }
  }

  renderProduct(product, variant) {
    const image = product.featuredImage;
    const price = product.priceRange.minVariantPrice;
    const compareAtPrice = variant.compareAtPrice?.amount;

    this.innerHTML = `
      <div class="spellbinders-supply-card">
        ${
          image
          ? `
            <a href="${product.onlineStoreUrl || ('/products/' + product.handle)}">
              <img
                class="spellbinders-supply-card__image"
                src="${image.url}"
                alt="${image.altText || product.title}"
                loading="lazy"
              >
            </a>
          `
          : ''
        }

        <div class="spellbinders-supply-card__content">
          <h3 class="spellbinders-supply-card__title">
            <a 
              href="${product.onlineStoreUrl || ('/products/' + product.handle)}" 
              class="spellbinders-supply-card__link">
              ${product.title}
            </a>
          </h3>

          <div class="spellbinders-supply-card__price-container">
            <span class="spellbinders-supply-card__price">
              $${Number(price.amount).toFixed(2)}
            </span>
            ${
              compareAtPrice && Number(compareAtPrice) > Number(price.amount)
              ? `<span class="spellbinders-supply-card__compare-at-price">
                  $${Number(compareAtPrice).toFixed(2)}
                </span>`
              : ''
            }
          </div>

          ${
            variant?.availableForSale
            ? `
              <button
                type="button"
                class="spellbinders-supply-card__button"
                data-variant-id="${variant.id}"
              >
                Add to cart
              </button>
              `
              : `
              <button type="button" disabled>
                Sold out
              </button>
            `
          }
        </div>
      </div>
    `;

    const atcButton = this.querySelector('[data-variant-id]');
    if (atcButton) {
      atcButton.addEventListener('click', () => {
        this.addToCart(atcButton.dataset.variantId);
      });
    }
  }

  async addToCart(variantId) {
    const cartDrawer = document.querySelector('cart-drawer');
    const sections = cartDrawer?.getSectionsToRender?.().map((section) => section.id) || [];

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId.replace('gid://shopify/ProductVariant/', ''),
          quantity: 1,
          sections,
          sections_url: window.location.pathname,
          properties: {
            '_blog_cart': true
          },
        }),
      });

      const parsedState = await response.json();

      if (cartDrawer && cartDrawer.dataset.cartType === 'drawer') {
        const isClosedCart = !document.body.classList.contains('page-overlay-cart-on');
        cartDrawer.renderContents(parsedState, isClosedCart);
        return;
      }

      document.dispatchEvent(new CustomEvent('cart-drawer:refresh', {
        bubbles: true,
        composed: true,
      }));
    } catch(error) {
      console.error('Error adding product to cart:', error);
    }
  }
}

customElements.define('spellbinders-supplies', SpellbindersSupplies);